import { mapEntityProperties } from '@/utils/mapEntityProperties'
import {
  MonitoringCargoRouteEntity,
  PackageMonitoringRouteEntity
} from '@/features/trackOrder/domain/entities/packageEntites/PackageMonitoringRouteEntity'
import type { GetPackageCargosMonitoringRoutesResponseAdmin } from '@/backend/market'

export class PackageMonitoringRouteModel extends PackageMonitoringRouteEntity {
  constructor(dataDto: GetPackageCargosMonitoringRoutesResponseAdmin) {
    super()
    mapEntityProperties<PackageMonitoringRouteEntity>(
      this,
      dataDto as unknown as Partial<Record<keyof PackageMonitoringRouteEntity, unknown>>,
      {
        map: {
          monitoringCargoRoutes: dataDto.monitoringCargoRoutes?.map((route) => {
            const entity = new MonitoringCargoRouteEntity()
            mapEntityProperties<MonitoringCargoRouteEntity>(entity, route)
            return entity
          }),
          trackedDriverRoute: dataDto.trackedDriverRoute
            ? {
                route: dataDto.trackedDriverRoute.route
              }
            : undefined,
          currentDriverLocation: dataDto.currentDriverLocation
        }
      }
    )
  }
}
